export { default as baseStyles} from './global'


// WEBPACK FOOTER //
// ./src/app/components/styled/global/index.js